import queryClient from '../../../ReactQuery/client';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';
import { nuc } from '../../../utils';
import { plural } from '../../../../shared/helpers/plural';

export type BlockPackageVersionsParams = {
  packageLocator: string;
  policyIds: number[];
  versions: string[] | 'ALL';
};

const blockPackageVersions = ({ packageLocator, policyIds, versions }: BlockPackageVersionsParams) => post(
  `/api/packages/${nuc(packageLocator)}/rules`,
  { policyIds, versions },
);

export default function useBlockPackageVersions() {
  return useToastedMutation({
    mutationFn: blockPackageVersions,
    successToastMessage: (_data, variables) => variables.versions === 'ALL'
      ? 'Blocked all versions of this package.'
      : `Blocked ${variables.versions.length} ${plural(variables.versions.length, 'version')} of this package.`,
    errorToastMessage: 'Failed to block package versions',
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({ queryKey: ['packages', variables.packageLocator, 'versions'] });
      void queryClient.invalidateQueries({ queryKey: ['packages', 'list'] });
      void queryClient.invalidateQueries({ queryKey: ['packages', variables.packageLocator, 'metadata'] });
    },
  });
}
